import { render, staticRenderFns } from "./NewsletterItemDetail.vue?vue&type=template&id=cbdc03d4&"
import script from "./NewsletterItemDetail.vue?vue&type=script&lang=js&"
export * from "./NewsletterItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports